import { lazy } from 'react';

const Footer = lazy(() => import('./Footer'));

export { Footer };
